import { render } from "./RankPrivilege.vue?vue&type=template&id=7e5b0328&scoped=true"
import script from "./RankPrivilege.vue?vue&type=script&lang=js"
export * from "./RankPrivilege.vue?vue&type=script&lang=js"

import "./RankPrivilege.vue?vue&type=style&index=0&id=7e5b0328&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5b0328"]])

export default __exports__